import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CloseAgencyRequest, CreateAgencyRequest, GetAgenciesRequest, GetAgencyRequest, ReopenAgencyRequest, UpdateAgencyRequest } from "./api";

type Props = {
    onSuccess?: (data: any) => void;
    onError?: (error: any) => void;
}

const useCreateAgency = (props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(CreateAgencyRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['agencies']);
            queryClient.invalidateQueries(['agencies', `${data.id}`]);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useUpdateAgency = (props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(UpdateAgencyRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['agencies']);
            queryClient.invalidateQueries(['agencies', `${data.id}`]);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useCloseAgency = (props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(CloseAgencyRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['agencies']);
            queryClient.invalidateQueries(['agencies', `${data.id}`]);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useReopenAgency = (props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(ReopenAgencyRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['agencies']);
            queryClient.invalidateQueries(['agencies', `${data.id}`]);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useGetAgency = (agencyId: number, props?: Props) => {
    const {data, isLoading, isError} = useQuery<any>(['agencies', `${agencyId}`], () => GetAgencyRequest(agencyId), {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
    });

    return {data, isLoading, isError};
};

const useGetAgencies = (props?: Props) => {
    const {data, isLoading, isError} = useQuery<any>(['agencies'], GetAgenciesRequest, {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
    });

    return {data, isLoading, isError};
};

export { useCreateAgency, useUpdateAgency, useCloseAgency, useReopenAgency, useGetAgency, useGetAgencies };